import type { Block } from 'blockly/core';

import { arduinoGenerator, blockTraceComment, Order } from './arduino-generator.js';

function statementPrefix(block: Block, code: string): string {
  return `${blockTraceComment(block)}\n${code}`;
}

/**
 * Generators for Beginner Loop blocks.
 * Repeat (`controls_repeat_ext`) and Forever (`beginner_forever`) are registered elsewhere.
 */
export function registerBeginnerLoopGenerators(): void {
  arduinoGenerator.forBlock['beginner_repeat_until'] = (block: Block) => {
    const condition = arduinoGenerator.valueToCode(block, 'CONDITION', Order.NONE) || 'false';
    const branch = arduinoGenerator.statementToCode(block, 'DO');
    // Keep going while the condition is false; stop when it becomes true.
    return statementPrefix(block, `while (!(${condition})) {\n${branch}}\n`);
  };

  arduinoGenerator.forBlock['beginner_break_loop'] = (block: Block) => {
    return statementPrefix(block, 'break;\n');
  };
}

registerBeginnerLoopGenerators();
